import axios from 'axios';
import React, {
  Component,
} from 'react';

import moment from 'moment';
var api = require('./Config');
var SAVINGS_DEPOSITS = 'api/retriveSavingAccount';
var HOME_PAGE_API = 'api/retriveWebModuleService';
var SAVINGS_RANGE = 'api/retriveSavingsAccByDateRage?savAccId=';
var SAV_ACCOUNTS = 'api/retriveSavingAccount';
var OWN_ACCOUNT_TRANSFER = 'api/transferMoneyOwnAccount';
var BANK_LIST = 'api/listBanksForAPI';
var BRANCH_LIST = 'api/listBankBranches?bankId=';
var OTP_REF = 'api/createOTPCode';
var EXISTING_PAYEE = 'api/getExistingPayee';
var GET_COUNTRY_CODE = 'api/callingCode';
var FIRST_PASSWORD = 'anonymous/checkTransactionPassword?userId=';
var CREATE_NEWPAYEE= 'api/createNewPayee';
var GET_ACCOUNT_NUM='api/checkSenkAccount?accountNo=';
var CREATE_VOUCHER_API = 'api/createVoucher';
var CONFIRM_VOUCHER_OTP = 'api/acceptVoucher?otpCode=';
var RESEND_OTP = 'api/resendOTPCode?otpRef=';
var GET_DAILY_LIMIT = 'api/getCurrentDailyTransferLimit?accountNo=';
var NEW_LIMIT_REQUEST='api/updateDailyTransferLimit?currentTransferLimit=';
var REMOVE_RECIPIENT = 'api/removeWebPayee?payeeId=';
var UPDATE_BENE = 'api/updateWebPayee';
var TRANSFER_SUMMARY = 'api/retriveSearchSavTransferAPT?accountNo=';
var GET_PAYMENTS_DETAIL = 'api/retriveSavTransferByRefNumber?refNumber=';
var STOP_PAYMENTS = 'api/cancelSavTransfer?transId=';
var GET_EXIST_STANDINGORDERS = 'api/getExistingStandingOrder';
var REMOVE_STAND_RECIPIENT = 'api/removeStoBene?stoId=';
var STANDING_SUMMARY = 'api/retriveSearchStandingOrder?accountNo=';
var GET_STANDORDER_DETAIL = 'api/retriveStandingOrderByStnoRef?stOrdId=';
var GET_ACTIVE_STAND = 'api/retriveCustStandOrder?';
var STOP_STANDORDER = 'api/suspendStandingOrder?stanOrdId=';
var AMMEND_STANDORDER = 'api/updateStandingOrder';
var CREATE_STANDING_ORDER = 'api/createStandingOrder';
var ACCEPT_STANDINGORDERS = 'api/acceptStandingOrder?otpCode=';
var RECENT_TRANSACTIONS = 'api/recentTransactions?savAccId=';
var token = '';
var initPromises = [];


class CommonAPI extends React.Component{

    constructor(props){
      super(props);
      //initPromises.push(this.getToken());
        this.state = { 
        FACode: null,  
      };
    }
    
  
    async homeApi(cb){
      var self = this;
  
         return  await axios({
              method: 'get',
              url: api.HOST+HOME_PAGE_API,       
              headers: {
                'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },        
            }).then((responses)=>{  
          //console.log(responses);
            if(responses.status >= 200 && responses.status<300){
              //self._setAuthData(responses.headers);
              return responses;
            }        
          })        
          .then((results)=>{ 
              return cb(results.data)
            })       
            .catch ((err)=>{
              // console.log('Login Fail : ' +err)
            // this.status(err);
              return cb (err);
              console.log("errr  : status : "+err.response.status);  
            })
          .finally(()=>{
              //this.setState({showProgress:false});
            });
    }  

    async SavingsAccounts(details) {
      
        return await axios({
          url:api.HOST+SAVINGS_DEPOSITS,
          method: "GET",
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        }).then((response)=>{
          if(response.data.status===401){
            this.setState({logout:true});
            //this.logOut();
         }
         if(response.status >= 200 && response.status<300){          
          return response;
          } 
         return response;
        }) 
        .then((result) => {          
          return details(result.data);
        }).catch((error)=> {
          return details(error.response);
          console.log(error);
      });      
    }

    async FetchBankList(banklist) {      
        return await axios({
          url:api.HOST+BANK_LIST, 
          method: "GET",
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}` ,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {            
          return banklist(result.data.data);
        }).catch((error)=> {
          return banklist(error.response);
          console.log(error);
      });      
    }

    async FetchBranchList(bankid,branchlist) {      
      return await axios({
        url:api.HOST+BRANCH_LIST+bankid.bid, 
        method: "GET",
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}` ,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {            
        return branchlist(result.data.data);
      }).catch((error)=> {
        return branchlist(error.response);
        console.log(error);
    });      
  }
    
  async SavingsDescriptionAPI(dateils,cb ){
    return await axios({
      method: "GET",
      url:api.HOST+SAVINGS_RANGE+dateils.AccID+'&fromDate='+moment(dateils.Sdate).format('DD/MM/YYYY')+'&toDate='+moment(dateils.Edate).format('DD/MM/YYYY'),               
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {        
        return cb(result);
      }).catch((error)=> {
        console.log(error);
        return cb(error.response);
    });
  }

  async FromToAccountAPI(accounts ){
    return await axios.get(api.HOST+SAV_ACCOUNTS,{            
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {        
        return accounts(result);
    }).catch((error)=> {
      console.log(error);
      return accounts(error.response);
  });
  }

  async FetchOTPReference(otpRef) {   
      return await axios({
        method: "GET",
        url:api.HOST+OTP_REF,         
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {
         return otpRef(result.data.otpRef); 
      }).catch((error)=> {
        return otpRef(error.response);
    })    
  }
  
  async GetExistingPayee(ExistPayeeList) {

      return await axios({
        method: "GET",
        url:api.HOST+EXISTING_PAYEE,         
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {          
          return ExistPayeeList(result.data);            
      }).catch((error)=> {
        console.log(error);
        return ExistPayeeList(error.response);        
    })    
  }

  async GetCountryCode(code){
    return await axios({
     method: "GET",
      url:api.HOST+GET_COUNTRY_CODE,                
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {
        return code(result.data);   
    }).catch((error)=> {
      return code(error.response);
  });
}
async CheckPassword (pw,returnPW){       
  return await axios({
    method: "GET",
    url:`${api.HOST}${FIRST_PASSWORD}${JSON.parse(sessionStorage.getItem("userId")).id}&password=${encodeURIComponent(pw.password)}`,    
    headers: {
      'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {    
    return returnPW(result.data)
  }).catch((error)=> {
    console.log(error);
    return returnPW(error.response)
  });
}

async SaveNewPayee(pl,newpayee) {
    return await axios({
      method: "POST",
      url:api.HOST+CREATE_NEWPAYEE,         
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
            "accountNo":pl.fromAccount,
            "beneName":pl.beneName,
            "beneBankId":pl.beneBankId,
            "beneBankBrId":pl.beneBankBrId,
            "beneAccountNo": pl.beneAccountNo,
            "reference":pl.reference,
            "paymentOption": "",
            "benePhone": pl.benePhone,
            "beneEmail" : pl.beneEmail,
            "beneReference":pl.beneReference
          }),
        })
        .then((result) => {          
          return newpayee(result.data);
        }).catch ((err)=>{
          return newpayee(err.response);
        });    
}

async CheckSenkadagalaAccounts(para,senkAcc){
  return await axios({
    method: "GET",
    url:api.HOST+GET_ACCOUNT_NUM+para.NewPayeeAccountNum,        
    headers: {
      'Authorization' :  `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {  
    return senkAcc(result.data);      
  }).catch((error)=> {
    return senkAcc(error.response);
});
}

async PayWithoutSaveNewPayee(pl,wres) {
  var payLoad =  JSON.stringify({
        "payee":pl.payee,
        "fromBankId": "37",
        "fromAccount":pl.fromAccount,
        "toBankId": pl.toBankId,
        "toAccount":pl.toAccount,
        "amount":pl.amount,
        "voucherDate":pl.voucherDate,
        "saveBenificiary": pl.saveBenificiary,
        "otpRef": pl.otpRef,
        "paymentOpt": pl.paymentOpt,
        "otpCode": "",
        "existPayee": pl.existPayee,
        "reference": pl.reference,
        "beneReference": pl.beneReference,
        "toBankBrId":pl.toBankBrId,
        "beneCountryCode":pl.beneCountryCode,
        "benePhone":pl.benePhone,
        "beneEmail": pl.beneEmail,
        "payeeId":pl.payeeId,
        "deviceType": "WEB"
  });

  return await axios({
      method: "POST",
      url:api.HOST+CREATE_VOUCHER_API,         
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
     data: payLoad,
    })
    .then((result) => {
      wres(result.data);
    }).catch ((err)=>{
      console.log(err.response);
      wres(err.response);
      });  
    }

    TransferConfirmOTP = async (para,returnVla) =>{
      return await axios({
        method: "GET",
        url:api.HOST+CONFIRM_VOUCHER_OTP+para.EnteredOTP+'&deviceType='+'WEB',         
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {    
          return returnVla(result.data);
      }).catch((error)=> {
        return returnVla(error.response);
        console.log(error);
    })
    }

    async ResendOTP(para,returnVla)  {  
        return await  axios({
          method: "GET",
          url:api.HOST+RESEND_OTP+para.OtpReference,        
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {        
            return returnVla(result.data);
        }).catch((error)=> {
          return returnVla(error.response);
          console.log (error);
      })  
    }

    async GetCurrentTransferLimit(para,returnVla)  { 
      return await  axios({
      method: "GET",
      url: api.HOST+GET_DAILY_LIMIT+para.AccNum,
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).then((result) => {    
        return returnVla(result);
    }).catch((error)=> {
      return returnVla(error.response);
      console.log(error);
    });
    }

    async PostNewLimit(para,returnVla)  { 
      return await  axios({
      method: "GET",
      url: api.HOST+NEW_LIMIT_REQUEST+para.DailyLimit+'&newTransferLimit='+para.NewLimit+'&accountNo='+para.SelectFromAccount,
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).then((result) => {    
        return returnVla(result.data);
    }).catch((error)=> {
      return returnVla(error.response);
      console.log(error);
    });
    }

    async RemoveRecipient(pl,returnVal) {

      return await axios({
        method: "GET",
        url:api.HOST+REMOVE_RECIPIENT+pl.ExistSelectAccountID,                
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {     
          return returnVal(result.data);
      }).catch((error)=> {
        return returnVal(error.response);
        console.log(error);
    });  
    }

    async ConfirmEditBene(pl,returnVal){  
     return await axios({
       method: "POST",
       url:api.HOST+UPDATE_BENE,           
       headers: {
         'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
         'Content-Type': 'application/json'
       },

       data: JSON.stringify({
                 "id": pl.ExistSelectAccountID,
                 "beneName": pl.ExistBeneName,
                 "beneAccountNo": pl.ExistSelectToAccount,
                 "beneBankId": pl.NewBankId,
                 "beneBankName": pl.NewSelectBank,
                 "beneBankBrId": pl.NewSelectedBranchID,
                 "beneBrachName": pl.NewSelectedBranch,
                 "benePhone" : pl.ExistMobile,
                 "beneEmail" : pl.ExistEmail,
                 "beneEmail" : pl.ExistEmail==="Incorrect Email"?"":pl.ExistEmail,
                 "beneCountry":pl.ExistMobile?pl.ExistTeleCode:" ",
             }),
         })
         .then((result) => {          
             return returnVal(result.data);
         }).catch((error)=> {
          return returnVal(error.response);
           console.log(error);           
       });     
    }

    async GetPaymentSummary(pl,returnVal) {
      var UserAccount = pl.SelectToAccount?pl.SelectToAccount:""
          return await axios({
            method: "GET",
            url:api.HOST+TRANSFER_SUMMARY+UserAccount+'&beneName='+pl.EnteredBeneName,          
            headers: {
              'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          })
          .then((result) => {               
              return returnVal(result.data);
          }).catch((error)=> {
            return returnVal(error.response);
            console.log(error);
        });          
    }

    async GetTransferDetails(pl,returnVal) {          
        return await axios({
          method: "GET",
          url:api.HOST+GET_PAYMENTS_DETAIL+pl.PaymentsRefNumber,           
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        }).then((result) => {                
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });          
    }

    async StopPayments(pl,returnVal) {          
        return await axios({
          method: "GET",
          url:api.HOST+STOP_PAYMENTS+pl.PaymentsRefNumber,            
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });          
    }

    async GetExistSTORecipeientsAPI(returnVal) {          
        return await axios({
          method: "GET",
          url:api.HOST+GET_EXIST_STANDINGORDERS,            
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });        
    }

    async RemoveSTORecipeientAPI(pl,returnVal) {          
        return await axios({
         method: "GET",
          url:api.HOST+REMOVE_STAND_RECIPIENT+pl.StandAccountID,            
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });      
    }

    async GetSTOSummary(pl,returnVal) {
      var UserAccount = pl.SelectToAccount?pl.SelectToAccount:""
          return await axios({
            method: "GET",
            url:api.HOST+STANDING_SUMMARY+UserAccount+'&beneName='+pl.EnteredBeneName,          
            headers: {
              'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          })
          .then((result) => {               
              return returnVal(result.data);
          }).catch((error)=> {
            return returnVal(error.response);
            console.log(error);
        });          
    }

    async GetSTODetails (pl,returnVal) {    
        return await axios({
          method: "GET",
          url:api.HOST+GET_STANDORDER_DETAIL+pl.StandingOrderId,          
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {               
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });          
    }

    async GetActiveSTOSummary(pl,returnVal) {
      var acc = pl.accountNum?('bankAccNo='+pl.accountNum):null
          return await axios({
            method: "GET",
            url:api.HOST+GET_ACTIVE_STAND+acc,        
            headers: {
              'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          })
          .then((result) => {               
              return returnVal(result.data);
          }).catch((error)=> {
            return returnVal(error.response);
            console.log(error);
        });          
      }

    async StopSTO(pl,returnVal) {          
        return await axios({
          method: "GET",
          url:api.HOST+STOP_STANDORDER+pl.StandingOrderId,            
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
        })
        .then((result) => {
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });          
    }
    async AmmendStandingOrder(pl,returnVal){
      
      return await axios({
          method: "POST",
          url:api.HOST+AMMEND_STANDORDER,         
          headers: {
            'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
                  "id": pl.StandingOrderId,
                  "bankAccNo": pl.BeneBankAccountNum,
                  "frequency": pl.PayeeFrequency,
                  "amount": pl.Amount,
                  "startDate": pl.StartDate,
                  "endDate": pl.AmmendEndDate
                }),    
        })
        .then((result) => {
            return returnVal(result.data);
        }).catch ((err)=>{
          return returnVal(err.response);
        });
    }

    async CreateStandingOrderAPI(pl,returnVal){    
      return await axios({
        url:api.HOST+CREATE_STANDING_ORDER,
        method: "POST",
        headers: {
          'Authorization' :  `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/json'
        },  
        data: JSON.stringify({
                    "isExist": pl.isExist,
                    "bankBrId": pl.ExistSelectToBankBranchID,
                    "savingsAccountId": pl.ExistSelectFromAccountID,
                    "otpReference": pl.OtpReference,
                    "beneSave": pl.beneSave,
                    "payOption": pl.ExistTransferOpt,
                    "beneName": pl.ExistBeneName,
                    "beneAdd1": pl.ExistBeneAdd1,
                    "beneAdd2": pl.ExistBeneAdd2,
                    "bankAccNo": pl.ExistSelectToAccount,
                    "frequency": pl.ExistPayeeFrequency,
                    "startDate": pl.ExistPayeeFirstDate,
                    "endDate":pl.ExistPayeeEndDate,
                    "amount": pl.ExistEnteredAmount,
                    "beneReference":pl.ExistBeneRef,
                    "reference": pl.ExistYourRef,
                    "deviceType": "WEB"
                  }),                      

      }).then((result) => {
          return returnVal(result.data);
      }).catch((error)=> {
        console.log(error);
        return returnVal(error.response)
    });
    }

    async AcceptSTO(pl,returnVal) {          
          return await axios({
           method: "GET",
            url:api.HOST+ACCEPT_STANDINGORDERS+pl.EnteredOTP+'&deviceType='+'WEB',            
            headers: {
              'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          })
          .then((result) => {
              return returnVal(result.data);
          }).catch((error)=> {
            return returnVal(error.response);
            console.log(error);
        });          
    }

    async RecentTransactions(pl,returnVal) {          
      return await axios({
       method: "GET",
        url:api.HOST+RECENT_TRANSACTIONS+pl.SavID,            
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {
          return returnVal(result.data);
      }).catch((error)=> {
        return returnVal(error.response);
        console.log(error);
    });          
}        

}

export default new CommonAPI();
